const state = () => ({
  authMethods: [],
});

const getters = {
  authMethods: state => state.authMethods,
};

const mutations = {
  setAuthMethods: (state, val) => {
    state.authMethods = val;
  },
};

const actions = {};

export default {
  state,
  getters,
  actions,
  mutations,
};
